import type { StudentToofiOpenIntent, ToofiEntryDescriptor, ToofiEntrySeed } from "@/types/student-toofi";

export const normalizeStudentToofiOpenIntent = (intent?: StudentToofiOpenIntent | null): StudentToofiOpenIntent => ({
  open: intent?.open ?? true,
  prompt: typeof intent?.prompt === "string" ? intent.prompt.trim() : "",
  threadId: intent?.threadId ?? null,
  linkedResourceId: intent?.linkedResourceId ?? null,
  linkedPlanId: intent?.linkedPlanId ?? null,
  productMode: intent?.productMode ?? null,
  productIntent: intent?.productIntent ?? null,
  modeSelectionSource: intent?.modeSelectionSource ?? null,
  entryPointId: typeof intent?.entryPointId === "string" ? intent.entryPointId.trim() : null,
  memoryMode: intent?.memoryMode === "temporary" ? "temporary" : intent?.memoryMode === "default" ? "default" : null,
});

export const buildStudentToofiSeedIntent = (seed: ToofiEntrySeed): StudentToofiOpenIntent =>
  normalizeStudentToofiOpenIntent({
    open: true,
    prompt: seed.prompt ?? "",
    threadId: seed.threadId ?? null,
    linkedResourceId: seed.linkedResourceId ?? null,
    linkedPlanId: seed.linkedPlanId ?? null,
    productMode: seed.productMode,
    productIntent: seed.productIntent ?? null,
    modeSelectionSource: "seeded",
    entryPointId: seed.entryPointId,
    memoryMode: null,
  });

export const buildToofiEntryDescriptor = (
  label: string,
  icon: ToofiEntryDescriptor["icon"],
  seed: ToofiEntrySeed,
  helper?: string | null,
): ToofiEntryDescriptor => ({
  label,
  icon,
  helper: helper ?? null,
  seed,
});
